"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHAPTER_WITH_HIGHLIGHT_FIELDS = exports.CHAPTER_FIELDS = void 0;
const client_1 = require("@apollo/client");
const highlight_1 = require("./highlight");
const picture_1 = require("./picture");
exports.CHAPTER_FIELDS = (0, client_1.gql) `
  ${picture_1.PICTURE_FIELDS}
  ${highlight_1.HIGHLIGHT_FIELDS}
  fragment ChapterFields on Chapter {
    id
    explanation
    summary
    typeId
    pictures {
      ...PictureFields
    }
    highlights {
      ...HighlightFields
    }
    files {
      id
      title
      url
      videoId
      conceptId
    }
  }
`;
// used in cache updator
exports.CHAPTER_WITH_HIGHLIGHT_FIELDS = (0, client_1.gql) `
  fragment ChapterWithHighlightFields on Chapter {
    highlights {
      start
      end
      text
      part
      tag
      color
    }
  }
`;
